module.exports = __webpack_public_path__ + "img/notes-2.07f136c5.jpg";